<template>
  <div class="mobile-top-header-wrap" :style="headerStyle">
    <div class="back" v-if="isBack" @click="backRouter">
        <div class="icon-left" :style="{'--setBg':fontColor}"></div>
    </div>
    <span v-if="titleType == 'text'" class="title">{{title}}</span>
    <img v-if="titleType == 'image'" src="@/assets/mobile/chat/chatTitle.png" class="titleImage">
    <!-- 右侧菜单 -->
    <div class="rightIcon" @click="handle">
        <img class="addIcon" v-if="rightButtonType == 1" src="@/assets/chat/addSession.png" alt="">
        <img class="screenIcon" v-if="rightButtonType == 2" src="./images/screen.png" alt="">
        <img class="settingIcon" v-if="rightButtonType == 3 && chatType == 'app'" src="./images/setting.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
    props:{
        path:{
            type:String,
            default:""
        },
        title:{
            type:String,
            default:""
        },
        // 类型 text 文字 image 图片
        titleType:{
            type:String,
            default:"text"
        },
        bg:{
            type:String,
            default:'#fff'
        },
        fontColor:{
            type:String,
            default:'#000'
        },
        // 默认显示返回按钮
        isBack:{
            type:Boolean,
            default:true,
        },
        // true 表示当前正在对话中，需要中断请求
        loading:{
            type:Boolean,
            default:false
        },
        /**
         * @description: 顶部右侧图标
         * 1 新建绘画
         * 2 过滤
         * 3 设置
         * */
        rightButtonType:{
            type:Number,
            default:0
        },
        chatType:{
            type:String,
            default:'app'
        }
    },
    watch:{
        bg:{
            handler(newVal,oldVal){
                this.headerStyle.background = newVal;
            },
            deep:true
        },
        fontColor:{
            handler(newVal,oldVal){
                this.headerStyle.color = newVal;
            },
            deep:true
        }
    },
    name:"mobileTopHeader",
    data(){
        return{
            headerStyle:{
                background:this.bg,
                color: this.fontColor
            },
            show:true

        }
    },
    methods:{
        backRouter(){
            if(this.loading){
                this.$emit('customBack')
            }else{
                if(this.path){
                    this.$openChatRouter({path:this.path});
                }else{
                    this.$router.back()
                }
            }
        },
        handle(){
            this.$emit('handle')
            // if(this.rightButtonType == 1){
            //     this.$emit('handle')
            // }else if(this.rightButtonType == 2){
            //     console.log('到底');
            // }
            
        },
    }

}
</script>

<style lang="less" scoped>
.mobile-top-header-wrap{
    width: 100%;
    height: .44rem;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index:999;
    padding: 0 .18rem;
    .back{
        width:.44rem;
        height: 100%;
        display: flex;
        align-items: center;
       
        .icon-left{
            width: .12rem;
            height: .12rem;
            position: relative;
            display: inline-block;
            transform: rotate(180deg);
            &::after,
            &::before{
                width: .12rem;
                height: .02rem;
                content: '';
                background: var(--setBg);
                display:block;
                position: absolute;
                border-radius: .02rem;
            }
        }
       
        .icon-left::before{
            top: 0;
            left: 0;
            transform:translateY(.01rem) rotate(45deg);

        }
        .icon-left::after{
            bottom: 0;
            left: 0;
            transform:translateY(-.01rem) rotate(-45deg);
        }
    }
    .title{
        font-size: .16rem;
        // color:#000000;
        position: absolute;
        top: 50%;
        left: 50%;
        transition: color .2s ease;
        transform: translate(-50%,-50%);
    }
    .titleImage{
        width: .6732rem;
        height: .16rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .rightIcon{
        width: .44rem;
        height: 100%;
        position: absolute;
        right: .16rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .addIcon{
            width: .24rem;
            height: .24rem;
        }
        .screenIcon{
            width: .16rem;
            height: .16rem;
        }
        .settingIcon{
            width: .22rem;
            height: .04rem;
        }
    }

}
</style>